import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;

const styles = makeStyles(theme => ({
  iconUrl: {
    fontWeight: 300,
    fill: "#0073cf",
    fontSize: "14px"
  },
  colorExpandMore: {
    fill: "#e7e7e7"
  },
  drawer: {
    "& .MuiBackdrop-root": {
      opacity: "0 !important"
    },
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  drawerPaper: {
    // width: drawerWidth
    width: "100%",
    height: "calc(100% - 90px)",
    marginTop: "91px",
    backgroundColor: "white"
  },
  containerDrawer: {
    padding: "0",
    flexDirection: "column"
  },
  marginItem: {
    marginTop: "15px"
  },
  textStyle: {
    color: "black",
    fontWeight: 700
  },
  listItem: {
    width: "100%"
  },
  nested: {
    paddingLeft: "25px"
  },
  selected: {
    color: theme.palette.primary.dark,
    backgroundColor: "transparent !important"
  },
  textPrimary: {
    paddingLeft: "0",
    // color: "#666666",
    "& span": {
      fontSize: 14,
      color: theme.palette.primary.dark,
      fontWeight: "bold"
    }
  },
  textSecondary: {
    // color: "#666666",

    "& span": {
      color: theme.palette.primary.dark,
      fontWeight: "normal",
      fontSize: 14
    }
  },
  dividerClass: {
    backgroundColor: "white"
  },
  uniqueLinkPrimary: {
    backgroundColor: "#ededed",
    "& $textPrimary span": {
      fontWeight: "normal"
    }
  }
}));

export default styles;
